'use client';
import React from 'react';

const FaqAccordion = ({ onContactSupport }) => {
  const faqItems = [
    {
      question: 'What is the average Vietnam trip cost from India?',
      answer: 'The average Vietnam trip cost from India usually starts from around ₹45,000 to ₹60,000 per person for budget packages. Standard and premium packages may cost more depending on flights, hotels, itinerary, and season.',
    },
    {
      question: 'Which is the best Vietnam tour package for first-time travellers?',
      answer: 'A 6 to 7-day package covering Hanoi, Halong Bay, Da Nang, Ba Na Hills, and Hoi An is ideal for first-time travellers.',
    },
    {
      question: 'Do Vietnam tour packages from India include flights?',
      answer: 'Yes, we can arrange Vietnam tour packages with flights from major Indian cities. You can also book a land-only package if you already have flights.',
    },
    {
      question: 'Is Vietnam good for couples?',
      answer: 'Yes, Vietnam is a great destination for couples. A Vietnam tour package for couple can include romantic stays, cruises, beaches, lantern streets, private transfers, and honeymoon experiences.',
    },
    {
      question: 'What is the Vietnam trip cost from India for couple?',
      answer: 'The Vietnam trip cost from India for couple usually depends on flights, hotel category, duration, and inclusions. A comfortable couple package may start from around ₹90,000 to ₹1,30,000 for two people, excluding major seasonal price changes.',
    },
    {
      question: 'How many days are enough for a Vietnam tour?',
      answer: 'A Vietnam package tour 7 days is ideal for covering the main highlights. For a relaxed holiday, 8 to 10 days is better.',
    },
    {
      question: 'Can I customize my Vietnam travel package?',
      answer: 'Yes, you can customize your Vietnam travel package from India based on destination, hotel category, sightseeing, flights, transfers, and budget.',
    },
    {
      question: 'Is Vietnam affordable for Indian travellers?',
      answer: 'Yes, Vietnam is one of the most affordable international destinations for Indian travellers. The overall Vietnam tourism cost is budget-friendly compared to many other countries.',
    },
    {
      question: 'Which cities are covered in Vietnam holiday packages?',
      answer: 'Popular cities covered in Vietnam holiday packages from India include Hanoi, Halong Bay, Da Nang, Hoi An, Ho Chi Minh City, Ninh Binh, and Phu Quoc.',
    },
    {
      question: 'Are group tours available for Vietnam?',
      answer: 'Yes, Vietnam group tour packages are available for families, friends, corporate groups, and fixed departure travellers.',
    },
];

  const handleContactSupport = () => {
    if (onContactSupport) {
      onContactSupport();
    } else {
      // Fallback: scroll to element with id 'hero-section'
      const heroElement = document.getElementById('hero-section');
      if (heroElement) {
        heroElement.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="text-center mb-5">
            <h2 className="display-5 fw-bold mb-3 blue-brand-color">Frequently Asked Questions</h2>
            <p className="lead text-muted">Everything you need to know about our travel packages</p>
          </div>

          <div className="accordion accordion-flush" id="faqAccordion">
            {faqItems.map((item, index) => (
              <div className="accordion-item border-0 border-bottom" key={index}>
                <h2 className="accordion-header" id={`heading${index}`}>
                  <button
                    className="accordion-button collapsed bg-transparent fw-semibold py-4 d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${index}`}
                    aria-expanded="false"
                    aria-controls={`collapse${index}`}
                  >
                    <span className="blue-brand-color fw-bold me-2">{String(index + 1).padStart(2, '0')}.</span>
                    {item.question}
                  </button>
                </h2>
                <div
                  id={`collapse${index}`}
                  className="accordion-collapse collapse"
                  aria-labelledby={`heading${index}`}
                  data-bs-parent="#faqAccordion"
                >
                  <div className="accordion-body pt-0 pb-4 pt-3 ps-5 text-muted fade-in">
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <p className="text-muted mb-3">Still have questions?</p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <button 
                onClick={handleContactSupport}
                className="btn blue-brand-bg-color text-white fw-bold"
              >
                Contact Support
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Inline Animation Style */}
      <style jsx>{`
        .fade-in {
          transition: all 0.4s ease-in-out;
        }
        
        .btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          transition: all 0.3s ease;
        }
      `}</style>
    </div>
  );
};

export default FaqAccordion;